export default "__VITE_ASSET__88cbe94b__"